import Icon from "src/@core/components/icon";

export const ICON_MAS = <Icon icon="mdi:plus" />

export const ICON_SAVE = <Icon icon="material-symbols:save" />

export const ICON_CLOSE = <Icon icon="material-symbols:close" />

export const TABLE_VIEW = <Icon icon="material-symbols:table-eye" />
